import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doTrackMapViewToggle),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(buildSearchRequestPayload),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(resetFilters),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(trackSearchQuery),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(loadResults),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(loadResultsFromUrl),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(doFilterChanged),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(reloadResults),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(handleUrlChange),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(handleReservationStatusChanged),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(handlePageChange),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(hasLocationBeenSet),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(loadSearchHeader),
    _marked14 =
/*#__PURE__*/
regeneratorRuntime.mark(initializeUserLocationForSearch),
    _marked15 =
/*#__PURE__*/
regeneratorRuntime.mark(loadSearch),
    _marked16 =
/*#__PURE__*/
regeneratorRuntime.mark(doShowMapForMobileLoggedOut),
    _marked17 =
/*#__PURE__*/
regeneratorRuntime.mark(doShowAllVenues),
    _marked18 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSearch);

import * as logger from 'universal-logger';
import { call, takeLatest, takeEvery, fork, spawn, put, all, select } from 'redux-saga/effects';
import { push as updatePath, replace as replacePath, LOCATION_CHANGE } from 'react-router-redux';
import { selectDistanceUnit } from 'redux/modules/locale';
import { SET_IS_CLIENT } from 'redux/modules/device';
import { isLoggedIn } from 'redux/modules/user';
import { isMobileDevice } from 'helpers/isMobile';
import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { SEARCH } from 'constants/filter-sets';
import { LoginRoute } from 'features/Login/Login.route';
import { reservationStatusChanged } from 'features/Reservation/Reservation.saga';
import { pathSelector, filterSetFilters, filterSetFilterValue } from 'redux/saga/selectors';
import { timezoneDate } from 'helpers/time';
import { deepExtract } from 'helpers/deep';
import { ec } from 'helpers/multitrack';
import { isPresent } from 'helpers/verify';
import { scrollToTop } from 'redux/saga/helpers';
import { determineScheduleContext } from 'redux/saga/helpers/credit-cycle';
import { searchLayoutByName } from 'redux/saga/entities/bound';
import { selectSearchFilterWriteActions, searchFilterActions, selectSelectedVertical, selectSelectedCreditsRange } from './filters/filters.helpers';
import { SearchLocation } from './models/SearchLocation';
import { doLoadRadius, getResultType, getSelectedRadius, filterChanged, filtersChanged, TIME_DEFAULT, doSetupFilters } from './filters/filters.saga';
import { PATH as SEARCH_PATH } from './Search.route';
import { CLEAR_KEYWORD, CLEAR_LOCATION, selectActiveLocation, selectDefaultLocation, selectKeywordSearchBoxText, selectLocationSearchBoxText, setLocationTimezone, selectSelectedKeywordId, selectSelectedLocation, setDefaultLocation, SET_KEYWORD, selectKeywordOriginalValue } from './SearchBox/SearchBox.reducer';
import { DEFAULT_GEOLOCATION, EVENTS, FILTER_NAMES, HEADER_LAYOUT, INITIAL_VISIBLE_VENUE_COUNT, RESULT_TYPES, RESULTS_LAYOUT, VERTICALS } from './Search.constants';
import { selectActiveUrl, selectCurrentPage, selectFilteringDisabled, selectMapView, selectReloadCursor, setActiveUrl, setCurrentPage, setFilteringDisabled, setupFilters, setMapView, setReloadCursor, setSearchId, setVisibleVenues, TOGGLE_MAP_VIEW } from './Search.reducer';
import { getUserLocationForSearch, makeUrlFromLayout, selectCursorInLayout, selectFiltersFromSearchResults, selectKeywordAutocompleteEntryInLayout, selectLocationAutocompleteEntryInLayout, selectLocationAutocompleteFromSearchResults, selectLocationAutocompleteValueInLayout, selectDataFromResultsLayout, selectSchedulesInLayout, selectSearchIdInLayout, selectVenuesInLayout, selectLocationAutocompleteTimezoneInLayout, selectResultTypeFromSearchResults } from './Search.helpers';
var ACTIVITY = FILTER_NAMES.ACTIVITY,
    AMENITY = FILTER_NAMES.AMENITY,
    DATE = FILTER_NAMES.DATE,
    RADIUS = FILTER_NAMES.RADIUS,
    RESULT_TYPE = FILTER_NAMES.RESULT_TYPE,
    TIME = FILTER_NAMES.TIME,
    VERTICAL = FILTER_NAMES.VERTICAL,
    TO_TIME = FILTER_NAMES.TO_TIME,
    FROM_TIME = FILTER_NAMES.FROM_TIME,
    MAP_BOUNDS = FILTER_NAMES.MAP_BOUNDS,
    LEVEL = FILTER_NAMES.LEVEL;
export var loadPage = function loadPage(delta) {
  return {
    type: 'classpass/search/LOAD_PAGE',
    delta: delta
  };
};
export var showAllVenues = function showAllVenues() {
  return {
    type: 'classpass/search/SHOW_ALL_VENUES'
  };
};
export var reloadSearch = function reloadSearch() {
  return {
    type: 'classpass/search/RELOAD_SEARCH'
  };
};
export var selectSearchLocationChange = function selectSearchLocationChange(action) {
  return action.type === LOCATION_CHANGE && action.payload.pathname.indexOf(SEARCH_PATH) === 0;
};
export var selectIsToggleMapView = function selectIsToggleMapView(action) {
  return action.type === TOGGLE_MAP_VIEW;
};
export var selectIsClientChange = function selectIsClientChange(action) {
  return action.type === SET_IS_CLIENT;
};
export function doTrackMapViewToggle() {
  var isMapView;
  return regeneratorRuntime.wrap(function doTrackMapViewToggle$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(selectMapView);

        case 2:
          isMapView = _context.sent;

          if (!isMapView) {
            _context.next = 8;
            break;
          }

          _context.next = 6;
          return call(ec, EVENTS.viewMap);

        case 6:
          _context.next = 10;
          break;

        case 8:
          _context.next = 10;
          return call(ec, EVENTS.viewSchedules);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function buildSearchRequestPayload() {
  var _ref, _ref2, filters, location, searchBoxKeywordId, resultType, vertical, creditsRange, creditsRangeLow, creditsRangeHigh, filterPayload, timeRange, _timeRange$split, _timeRange$split2, ft, tt;

  return regeneratorRuntime.wrap(function buildSearchRequestPayload$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([select(filterSetFilters, SEARCH), select(selectActiveLocation), select(selectSelectedKeywordId), call(getResultType), select(selectSelectedVertical), select(selectSelectedCreditsRange)]);

        case 2:
          _ref = _context2.sent;
          _ref2 = _slicedToArray(_ref, 6);
          filters = _ref2[0];
          location = _ref2[1];
          searchBoxKeywordId = _ref2[2];
          resultType = _ref2[3];
          vertical = _ref2[4];
          creditsRange = _ref2[5];
          creditsRangeLow = creditsRange && creditsRange.low;
          creditsRangeHigh = creditsRange && creditsRange.high;
          filterPayload = _objectSpread({}, vertical !== VERTICALS.all && {
            vertical: vertical
          }, {
            // To get results with all verticals we must omit the verticals key
            date: deepExtract("".concat(DATE, ".value"), filters) || timezoneDate(deepExtract('timezone', location)),
            tag: searchBoxKeywordId ? [searchBoxKeywordId] : Object.keys(deepExtract("".concat(ACTIVITY, ".itemIdSelected"), filters, {})),
            lat: location.lat,
            lon: location.lon,
            place_id: location.placeId,
            result_type: resultType
          }, deepExtract("".concat(AMENITY, ".itemIdSelected"), filters, {}), deepExtract("".concat(LEVEL, ".itemIdSelected"), filters, {}), isPresent(creditsRangeLow) && {
            min_credits: creditsRangeLow
          }, isPresent(creditsRangeHigh) && {
            max_credits: creditsRangeHigh
          });

          if (location.mapBounds) {
            filterPayload.map_bounds = location.mapBounds;
          } else {
            filterPayload.radius = getSelectedRadius(filters);
          }

          timeRange = deepExtract("".concat(TIME, ".value"), filters);

          if (timeRange && timeRange !== TIME_DEFAULT) {
            _timeRange$split = timeRange.split('-'), _timeRange$split2 = _slicedToArray(_timeRange$split, 2), ft = _timeRange$split2[0], tt = _timeRange$split2[1];
            filterPayload.ft = ft;
            filterPayload.tt = tt;
          }

          return _context2.abrupt("return", {
            search_request: {
              filters: filterPayload
            }
          });

        case 17:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function resetFilters(filtersToOmit) {
  return regeneratorRuntime.wrap(function resetFilters$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(setFilteringDisabled(true));

        case 2:
          _context3.next = 4;
          return put(searchFilterActions.clearFilterSet(filtersToOmit));

        case 4:
          _context3.next = 6;
          return put(setFilteringDisabled(false));

        case 6:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function trackSearchQuery(result, filters) {
  var keywordAutoCompleteEntry, locationAutocompleteEntry, schedules, creditAmounts, _ref3, _ref4, selectedLocation, resultType, keywordSearchBoxText, keywordOriginalValue, keywordSelectedId, locationSearchBoxText, mapBoundsFilter, splitMapBounds, searchId, keywordHeaderType, locationHeaderType, placeId, centerLat, centerLon, _ref5, _ref6, maxCredits, minCredits, _ref7, _ref8, mapViewPortSouthWestLon, mapViewportSouthWestLat, mapViewportNorthEastLon, mapViewportNorthEastLat;

  return regeneratorRuntime.wrap(function trackSearchQuery$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          keywordAutoCompleteEntry = selectKeywordAutocompleteEntryInLayout(result);
          locationAutocompleteEntry = selectLocationAutocompleteEntryInLayout(result);
          schedules = selectSchedulesInLayout(result) || [];
          creditAmounts = schedules.filter(function (schedule) {
            return schedule.availability && schedule.availability.credits;
          }).map(function (schedule) {
            return schedule.availability.credits;
          });
          _context4.next = 6;
          return all([select(selectSelectedLocation), select(filterSetFilterValue, SEARCH, RESULT_TYPE), select(selectKeywordSearchBoxText), select(selectKeywordOriginalValue), select(selectSelectedKeywordId), select(selectLocationSearchBoxText)]);

        case 6:
          _ref3 = _context4.sent;
          _ref4 = _slicedToArray(_ref3, 6);
          selectedLocation = _ref4[0];
          resultType = _ref4[1];
          keywordSearchBoxText = _ref4[2];
          keywordOriginalValue = _ref4[3];
          keywordSelectedId = _ref4[4];
          locationSearchBoxText = _ref4[5];
          mapBoundsFilter = filters[MAP_BOUNDS];
          splitMapBounds = mapBoundsFilter && mapBoundsFilter.split(',');
          searchId = selectSearchIdInLayout(result);
          keywordHeaderType = keywordAutoCompleteEntry.type;
          locationHeaderType = selectedLocation && selectedLocation.type;
          placeId = locationAutocompleteEntry.place_id;
          centerLat = locationAutocompleteEntry.lat;
          centerLon = locationAutocompleteEntry.lon;
          _ref5 = creditAmounts.length > 0 ? [Math.max.apply(Math, _toConsumableArray(creditAmounts)), Math.min.apply(Math, _toConsumableArray(creditAmounts))] : [], _ref6 = _slicedToArray(_ref5, 2), maxCredits = _ref6[0], minCredits = _ref6[1];
          _ref7 = splitMapBounds || [], _ref8 = _slicedToArray(_ref7, 4), mapViewPortSouthWestLon = _ref8[0], mapViewportSouthWestLat = _ref8[1], mapViewportNorthEastLon = _ref8[2], mapViewportNorthEastLat = _ref8[3];
          _context4.next = 26;
          return all([put(setSearchId(searchId)), call(ec, EVENTS.searchQuery, {
            search_id: searchId,
            category: filters[VERTICAL],
            selection: JSON.stringify(filters),
            result_type: resultType,
            keyword_id: keywordSelectedId,
            keyword_box_text: keywordSearchBoxText,
            keyword_original_name: keywordOriginalValue,
            location_box_text: locationSearchBoxText,
            keyword_header_type: keywordHeaderType,
            location_header_type: locationHeaderType,
            place_id: placeId,
            radius: filters[RADIUS],
            map_view_north_east_lat: mapViewportNorthEastLat,
            map_view_north_east_lon: mapViewportNorthEastLon,
            map_view_south_west_lat: mapViewportSouthWestLat,
            map_view_south_west_lon: mapViewPortSouthWestLon,
            map_center_lat: centerLat,
            map_center_lon: centerLon,
            activity: filters[ACTIVITY],
            tt: filters[TO_TIME],
            ft: filters[FROM_TIME],
            min_credits: minCredits,
            max_credits: maxCredits
          })]);

        case 26:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
export function loadResults(client) {
  var page,
      payload,
      previousPageData,
      cursor,
      distanceUnit,
      _ref9,
      _ref10,
      result,
      venues,
      searchFilters,
      selectedRadiusId,
      selectedLocation,
      currentTimezone,
      updatedLayout,
      timezoneFromLayout,
      _args5 = arguments;

  return regeneratorRuntime.wrap(function loadResults$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          page = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : 1;
          payload = _args5.length > 2 ? _args5[2] : undefined;

          if (!(!payload && page === 1)) {
            _context5.next = 8;
            break;
          }

          _context5.next = 5;
          return call(buildSearchRequestPayload, client);

        case 5:
          payload = _context5.sent;
          _context5.next = 16;
          break;

        case 8:
          if (payload) {
            _context5.next = 16;
            break;
          }

          _context5.next = 11;
          return select(selectDataFromResultsLayout, page - 1);

        case 11:
          previousPageData = _context5.sent;
          cursor = selectCursorInLayout(previousPageData);
          payload = {
            search_request: {
              cursor: cursor
            },
            modules: Object.keys(previousPageData) // fetch the same modules

          };
          _context5.next = 16;
          return put(setReloadCursor(cursor));

        case 16:
          _context5.next = 18;
          return select(selectDistanceUnit);

        case 18:
          distanceUnit = _context5.sent;
          _context5.next = 21;
          return all([call(fetchEntity, searchLayoutByName, [client, RESULTS_LAYOUT, payload, {
            distanceUnit: distanceUnit
          }], {
            key: "".concat(RESULTS_LAYOUT, "_").concat(page)
          }), put(setCurrentPage(page))]);

        case 21:
          _ref9 = _context5.sent;
          _ref10 = _slicedToArray(_ref9, 1);
          result = _ref10[0];
          _context5.next = 26;
          return call(selectVenuesInLayout, result);

        case 26:
          _context5.t0 = _context5.sent;

          if (_context5.t0) {
            _context5.next = 29;
            break;
          }

          _context5.t0 = [];

        case 29:
          venues = _context5.t0;
          _context5.next = 32;
          return put(setVisibleVenues(venues.slice(0, INITIAL_VISIBLE_VENUE_COUNT)));

        case 32:
          _context5.next = 34;
          return select(filterSetFilters, SEARCH);

        case 34:
          searchFilters = _context5.sent;
          selectedRadiusId = deepExtract("".concat(RADIUS, ".value"), searchFilters);

          if (selectedRadiusId) {
            _context5.next = 39;
            break;
          }

          _context5.next = 39;
          return call(doLoadRadius);

        case 39:
          _context5.next = 41;
          return select(selectSelectedLocation);

        case 41:
          selectedLocation = _context5.sent;

          if (!selectedLocation) {
            _context5.next = 53;
            break;
          }

          currentTimezone = selectedLocation && selectedLocation.timezone;
          _context5.next = 46;
          return select(selectDataFromResultsLayout);

        case 46:
          updatedLayout = _context5.sent;
          _context5.next = 49;
          return call(selectLocationAutocompleteTimezoneInLayout, updatedLayout);

        case 49:
          timezoneFromLayout = _context5.sent;

          if (!(!currentTimezone && timezoneFromLayout)) {
            _context5.next = 53;
            break;
          }

          _context5.next = 53;
          return put(setLocationTimezone(timezoneFromLayout));

        case 53:
          _context5.next = 55;
          return call(determineScheduleContext, client, deepExtract("".concat(DATE, ".value"), searchFilters));

        case 55:
          return _context5.abrupt("return", {
            result: result,
            filters: payload.search_request.filters
          });

        case 56:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
export function loadResultsFromUrl(client, url) {
  var _ref11, _ref12, existingFilters, location, _ref13, result, filters;

  return regeneratorRuntime.wrap(function loadResultsFromUrl$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([select(filterSetFilters, SEARCH), select(selectActiveLocation)]);

        case 2:
          _ref11 = _context6.sent;
          _ref12 = _slicedToArray(_ref11, 2);
          existingFilters = _ref12[0];
          location = _ref12[1];
          _context6.next = 8;
          return call(loadResults, client, 1, {
            search_request: {
              hash: url,
              filters: {
                date: deepExtract("".concat(DATE, ".value"), existingFilters) || timezoneDate(deepExtract('timezone', location))
              }
            }
          });

        case 8:
          _ref13 = _context6.sent;
          result = _ref13.result;
          filters = _ref13.filters;
          _context6.next = 13;
          return put(setActiveUrl(url));

        case 13:
          _context6.next = 15;
          return put(setupFilters());

        case 15:
          return _context6.abrupt("return", {
            result: result,
            filters: filters
          });

        case 16:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
export function doFilterChanged(client, action) {
  var _ref14, result, filters, searchUrl, actionData, filterName, filterNames, allFilterNames;

  return regeneratorRuntime.wrap(function doFilterChanged$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return select(selectFilteringDisabled);

        case 3:
          if (!_context7.sent) {
            _context7.next = 5;
            break;
          }

          return _context7.abrupt("return");

        case 5:
          _context7.next = 7;
          return call(loadResults, client, 1);

        case 7:
          _ref14 = _context7.sent;
          result = _ref14.result;
          filters = _ref14.filters;
          _context7.next = 12;
          return spawn(trackSearchQuery, result, filters);

        case 12:
          searchUrl = makeUrlFromLayout(result);

          if (!searchUrl) {
            _context7.next = 16;
            break;
          }

          _context7.next = 16;
          return all([put(setActiveUrl(searchUrl)), put(updatePath(searchUrl))]);

        case 16:
          actionData = action && (action.data || action);
          filterName = actionData.filter, filterNames = actionData.filters;
          allFilterNames = filterNames || filterName && [filterName];

          if (!allFilterNames) {
            _context7.next = 22;
            break;
          }

          _context7.next = 22;
          return put(searchFilterActions.resetNeedsUpdate(allFilterNames));

        case 22:
          _context7.next = 27;
          break;

        case 24:
          _context7.prev = 24;
          _context7.t0 = _context7["catch"](0);
          logger.error('Failed while applying filters', _context7.t0);

        case 27:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[0, 24]]);
}
export function reloadResults(client) {
  var currentPage, payload, previousPageData, cursor;
  return regeneratorRuntime.wrap(function reloadResults$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return select(selectCurrentPage);

        case 2:
          currentPage = _context8.sent;

          if (!(currentPage > 1)) {
            _context8.next = 11;
            break;
          }

          _context8.next = 6;
          return select(selectDataFromResultsLayout, currentPage);

        case 6:
          previousPageData = _context8.sent;
          _context8.next = 9;
          return select(selectReloadCursor);

        case 9:
          cursor = _context8.sent;
          payload = {
            search_request: {
              cursor: cursor
            },
            modules: Object.keys(previousPageData)
          };

        case 11:
          _context8.next = 13;
          return call(loadResults, client, currentPage, payload);

        case 13:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
export function handleUrlChange(client, action) {
  var newUrl, activeUrl;
  return regeneratorRuntime.wrap(function handleUrlChange$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          newUrl = action.payload.pathname;
          _context9.next = 3;
          return select(selectActiveUrl);

        case 3:
          activeUrl = _context9.sent;

          if (!(newUrl === activeUrl)) {
            _context9.next = 6;
            break;
          }

          return _context9.abrupt("return");

        case 6:
          if (!(newUrl === SEARCH_PATH)) {
            _context9.next = 15;
            break;
          }

          _context9.next = 9;
          return put(setActiveUrl(SEARCH_PATH));

        case 9:
          _context9.next = 11;
          return call(resetFilters);

        case 11:
          _context9.next = 13;
          return call(loadResults, client);

        case 13:
          _context9.next = 17;
          break;

        case 15:
          _context9.next = 17;
          return call(loadResultsFromUrl, client, newUrl);

        case 17:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}
export function handleReservationStatusChanged(client) {
  return regeneratorRuntime.wrap(function handleReservationStatusChanged$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return call(reloadResults, client);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}
export function handlePageChange(client, _ref15) {
  var delta, currentPage, nextPage;
  return regeneratorRuntime.wrap(function handlePageChange$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          delta = _ref15.delta;
          _context11.prev = 1;
          _context11.next = 4;
          return select(selectCurrentPage);

        case 4:
          currentPage = _context11.sent;
          nextPage = currentPage + delta;
          _context11.next = 8;
          return all([call(scrollToTop), call(loadResults, client, nextPage)]);

        case 8:
          _context11.next = 13;
          break;

        case 10:
          _context11.prev = 10;
          _context11.t0 = _context11["catch"](1);
          logger.error('Failed while changing page', _context11.t0);

        case 13:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11, null, [[1, 10]]);
}
export function hasLocationBeenSet() {
  var _ref16, _ref17, hasDefaultLocation, hasSelectedLocation;

  return regeneratorRuntime.wrap(function hasLocationBeenSet$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return all([select(selectDefaultLocation), select(selectSelectedLocation)]);

        case 2:
          _ref16 = _context12.sent;
          _ref17 = _slicedToArray(_ref16, 2);
          hasDefaultLocation = _ref17[0];
          hasSelectedLocation = _ref17[1];
          return _context12.abrupt("return", !!hasDefaultLocation || !!hasSelectedLocation);

        case 7:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}
export function loadSearchHeader(client) {
  var _ref18, lat, lon;

  return regeneratorRuntime.wrap(function loadSearchHeader$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return select(getUserLocationForSearch);

        case 2:
          _ref18 = _context13.sent;
          lat = _ref18.lat;
          lon = _ref18.lon;
          _context13.next = 7;
          return call(fetchEntityIfNeeded, searchLayoutByName, [client, HEADER_LAYOUT, {
            header_request: {
              location: {
                lat: lat,
                lon: lon
              }
            }
          }]);

        case 7:
          return _context13.abrupt("return", _context13.sent);

        case 8:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}
export function initializeUserLocationForSearch(client) {
  var _ref19, lat, lon, defaultLocation, searchResultsData, _ref20, _ref21, place_id, name, timezone, searchHeaderData, headerLocation;

  return regeneratorRuntime.wrap(function initializeUserLocationForSearch$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return put(setFilteringDisabled(true));

        case 2:
          _context14.next = 4;
          return select(selectFiltersFromSearchResults);

        case 4:
          _ref19 = _context14.sent;
          lat = _ref19.lat;
          lon = _ref19.lon;

          if (!(lat && lon)) {
            _context14.next = 21;
            break;
          }

          _context14.next = 10;
          return select(selectDataFromResultsLayout);

        case 10:
          searchResultsData = _context14.sent;
          _context14.next = 13;
          return all([// eslint-disable-line camelcase
          select(selectLocationAutocompleteFromSearchResults), call(selectLocationAutocompleteValueInLayout, searchResultsData), call(selectLocationAutocompleteTimezoneInLayout, searchResultsData)]);

        case 13:
          _ref20 = _context14.sent;
          _ref21 = _slicedToArray(_ref20, 3);
          place_id = _ref21[0].place_id;
          name = _ref21[1];
          timezone = _ref21[2];
          defaultLocation = new SearchLocation({
            lat: lat,
            lon: lon,
            name: name,
            place_id: place_id,
            timezone: timezone
          }); // eslint-disable-line object-curly-newline

          _context14.next = 26;
          break;

        case 21:
          _context14.next = 23;
          return call(loadSearchHeader, client);

        case 23:
          searchHeaderData = _context14.sent;
          headerLocation = deepExtract('location_history.data.default_location', searchHeaderData, DEFAULT_GEOLOCATION);
          defaultLocation = new SearchLocation(headerLocation);

        case 26:
          _context14.next = 28;
          return put(setDefaultLocation(defaultLocation));

        case 28:
          _context14.next = 30;
          return put(setFilteringDisabled(false));

        case 30:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}
export function loadSearch(client) {
  var url, result, filters, _ref22, searchResultType, loggedIn, correctUrl, _ref23;

  return regeneratorRuntime.wrap(function loadSearch$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return select(pathSelector);

        case 3:
          url = _context15.sent;
          _context15.next = 6;
          return call(initializeUserLocationForSearch, client);

        case 6:
          if (!(url !== SEARCH_PATH)) {
            _context15.next = 32;
            break;
          }

          _context15.next = 9;
          return call(loadResultsFromUrl, client, url);

        case 9:
          _ref22 = _context15.sent;
          filters = _ref22.filters;
          result = _ref22.result;
          _context15.next = 14;
          return select(selectResultTypeFromSearchResults);

        case 14:
          searchResultType = _context15.sent;

          if (!(searchResultType && searchResultType === RESULT_TYPES.SCHEDULE)) {
            _context15.next = 23;
            break;
          }

          _context15.next = 18;
          return select(isLoggedIn);

        case 18:
          loggedIn = _context15.sent;

          if (loggedIn) {
            _context15.next = 23;
            break;
          }

          _context15.next = 22;
          return put(replacePath("".concat(LoginRoute().path, "/?returnTo=").concat(encodeURIComponent(url))));

        case 22:
          return _context15.abrupt("return", _context15.sent);

        case 23:
          _context15.next = 25;
          return call(makeUrlFromLayout, result);

        case 25:
          correctUrl = _context15.sent;

          if (!(url !== correctUrl)) {
            _context15.next = 30;
            break;
          }

          _context15.next = 29;
          return put(replacePath({
            pathname: correctUrl,
            state: {
              status: 301
            }
          }));

        case 29:
          return _context15.abrupt("return", _context15.sent);

        case 30:
          _context15.next = 39;
          break;

        case 32:
          _context15.next = 34;
          return call(loadResults, client, 1);

        case 34:
          _ref23 = _context15.sent;
          filters = _ref23.filters;
          result = _ref23.result;
          _context15.next = 39;
          return call(doSetupFilters);

        case 39:
          _context15.next = 41;
          return spawn(trackSearchQuery, result, filters);

        case 41:
          _context15.next = 46;
          break;

        case 43:
          _context15.prev = 43;
          _context15.t0 = _context15["catch"](0);
          logger.error('Error loading search', _context15.t0);

        case 46:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15, null, [[0, 43]]);
}
export function doShowMapForMobileLoggedOut() {
  var _ref24, _ref25, isUserLoggedIn, isUserOnMobileDevice;

  return regeneratorRuntime.wrap(function doShowMapForMobileLoggedOut$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return all([select(isLoggedIn), call(isMobileDevice)]);

        case 2:
          _ref24 = _context16.sent;
          _ref25 = _slicedToArray(_ref24, 2);
          isUserLoggedIn = _ref25[0];
          isUserOnMobileDevice = _ref25[1];

          if (!(isUserOnMobileDevice && !isUserLoggedIn)) {
            _context16.next = 9;
            break;
          }

          _context16.next = 9;
          return put(setMapView(true));

        case 9:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked16);
}
export function doShowAllVenues() {
  var results, venues;
  return regeneratorRuntime.wrap(function doShowAllVenues$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return select(selectDataFromResultsLayout);

        case 2:
          results = _context17.sent;
          _context17.next = 5;
          return call(selectVenuesInLayout, results);

        case 5:
          venues = _context17.sent;
          _context17.next = 8;
          return put(setVisibleVenues(venues));

        case 8:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked17);
}
export function watchSearch(client) {
  return regeneratorRuntime.wrap(function watchSearch$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return all([fork(takeEvery, selectIsToggleMapView, doTrackMapViewToggle), fork(takeLatest, reservationStatusChanged().type, handleReservationStatusChanged, client), fork(takeLatest, loadPage().type, handlePageChange, client), fork(takeLatest, showAllVenues().type, doShowAllVenues), fork(takeLatest, selectSearchLocationChange, handleUrlChange, client), fork(takeLatest, selectIsClientChange, doShowMapForMobileLoggedOut), fork(takeLatest, reloadSearch().type, reloadResults, client), fork(takeLatest, [selectSearchFilterWriteActions, filterChanged().type, filtersChanged().type, SET_KEYWORD, CLEAR_KEYWORD, CLEAR_LOCATION], doFilterChanged, client)]);

        case 2:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked18);
}